<template>
  <div class="w-full h-64 lg:h-96"
    :style="{ background: 'url(' + background + ') no-repeat', backgroundSize: 'cover' }">
  </div>
  <div class="card block shadow-lg bg-white max-w-[560px] mx-auto -mt-10 lg:-mt-36 w-full justify-center"
    :class="{ 'pointer-events-none': loading }">
    <div class="card-body" :class="{ 'opacity-70': loading }">
      <p class="text-blue-custom-2 font-medium">{{ __('To the online store') }}</p>
      <p class="text-blue-custom-2 font-medium"><span class="text-lg font-extrabold text-blue-custom-2">{{ appName
      }}</span> {{ __('welcome') }}</p>
      <p class="text-xs font-medium mt-3 text-gray-custom-1">{{ __('Dear Colleague') }}:</p>
      <p class="text-xs font-medium text-gray-custom-1">{{ __('You must enter the site to use all sales and order online facilities. If you have not registered, register and authenticate your information through the link below')}}
      </p>
      <router-link class="btn btn-outline btn-primary btn-sm rounded-2xl mx-auto px-3 mt-4 mb-1" v-if="!enterCode"
        :to="{ name: 'register' }">{{ __('Registration and authentication') }}</router-link>
      <Form @submit="onSubmit" class="h-full flex flex-col" v-slot="{errors}">
        <div class="flex-1">
          <div class="flex justify-end" v-if="enterCode">
            <button type="button" class="flex justify-end" @click="backButton">{{ __('Back') }}
            <ArrowLongLeftIcon class="h-6 w-6 inline-block" />
          </button>
          </div>
          <div class="form-control mt-3">
            <Field type="tel" :disabled="enterCode" :placeholder="`${__('Enter your mobile number')}`"
              v-model="phone" :class="{ 'input-error': errors.phone }" name="phone" rules="required|digits:11" inputmode="numeric"
              class="input text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
            <Field v-if="enterCode" type="number" :placeholder="`${__('Verification code')}`" name="verification_code"
              v-model="verificationCode" :class="{ 'input-error': errors.verification_code }" rules="required"
              class="input mt-4 text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
            <button v-if="enterCode" type="button" class="btn btn-ghost !text-gray-custom-1 mt-3 mx-auto btn-sm"
              :class="{ 'pointer-events-none': timeout }" @click="resendCode">{{ timeout ? timeout : __('Request code again') }}
            </button>
          </div>
        </div>
        <div class="form-control">
          <button type="submit" class="btn btn-primary mt-4" :class="{ 'loading': loading }">{{ __(enterCode ? 'login' :
              'Send verification code')
          }}
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script setup>
import Auth from "../../../composables/shop/auth";
import { Field, Form } from "vee-validate";
import { computed, reactive, ref } from 'vue';
import { ArrowLongLeftIcon } from '@heroicons/vue/24/solid';
const loading = Auth.loading;
const errors = Auth.errors;
const enterCode = Auth.enterCode;
const timeout = Auth.timeout;
const phone = ref(null);
const verificationCode = ref(null);
const backButton = () => {
    enterCode.value = false;
    Auth.stopTimer();
}
const onSubmit = () => {
  if (enterCode.value) Auth.verification(phone.value, verificationCode.value);
  else Auth.login(phone.value);
}
const resendCode = () => Auth.login(phone.value);
const background = computed(() => window.APP_URL + '/assets/frontend/img/bg/auth.jpg');
const appName = computed(() => import.meta.env.VITE_APP_NAME);
</script>
